// extracted by css-extract-rspack-plugin
export default {"explicitValueFormControl":"DefinitionForm-module__explicitValueFormControl__cbXDy"};